
var plan_lists = [7,8,9,11,12];
$('.buy_tab>div span').click(function(){
    $(this).addClass('active').siblings().removeClass('active')
    $('.buy_main .buy_box').eq($(this).index()).addClass('active').siblings().removeClass('active')
})
$('.buy_box>div .check_box>div i').click(function(){
    var _index;
    for(var i = 0;i<$(this).parent().siblings('ul').find('li').length;i++){
        if($(this).parent().siblings('ul').find('li').eq(i).hasClass('active')){
            _index = i;
        }
    }
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan')+','+plan_lists[_index]);
    }else{
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan'));
    }
})
$(document).click(function(){
    $('.buy_box>div .check_box ul').hide()
})
$('.buy_box>div .check_box>div p').click(function(e){
    e.stopPropagation();
    var _flag = true;
    $(this).parent().siblings('ul').toggle();
})
$('.buy_box>div .check_box ul li').on('click',function(){
    var _index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active')
    $(this).parent().parent().find('p').html($(this).html());
    if($(this).parent().siblings('div').find('i').hasClass('active')){
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan')+','+plan_lists[_index]);
    }
})
$('.table_main .show_table').click(function(){
    $(this).toggleClass('active')
    $(this).next().find('table').toggleClass('active')
})
$('.faq_box>div .title').click(function(){
    $(this).parent().toggleClass('active').siblings().removeClass('active')
})
function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
}
var buy_first=0;
var isbuy=0;
window.open_google = true;
// ga跟踪代码
function gaPush(dataEvent,lable){
    try{
        // _gaq.push(['_trackEvent',operation,String(dataEvent),String(lable)]);
    }catch(e){
        // console.log(e)
    }
}
// 判断是否首次进入页面
if(localStorage.getItem('buy_first')){
    buy_first=1
}else{
    localStorage.setItem('buy_first',1)
}
if(location.hostname=='www.vidhex.ai'
){
    var paddle_vendor=183001;
    var fast_storefront='vidhexai.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}else{
    // Paddle.Environment.set('sandbox');
    var paddle_vendor=570;
    var fast_storefront='vidhexai.test.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}
var fastspringScript
// 请求购买链接
$('.buy_box span.btn').click(function(){
    if($(this).attr('class').indexOf('load')>-1){
        return false;
    }
    checkout($(this));
});
function checkout(that){
    var data={
        e_id:murmur,
        gateway:gateway,
        plan_id:that.attr('plan'),
    }
    gaPush('buy_fail','buy_planID',that.attr('plan'))
    that.addClass('load')
    $.post(
        post_url+"subscription/checkout",
        data,
        function(data){
            error_fn(data.error,that);
            switch(data.error){
                case 0:
                    if(gateway==4){
                        // 2checkout
                        (function (document, src, libName, config,data) {
                            var data=getUrlkey(data.url_gateway)
                            var script             = document.createElement('script'); 
                            script.src             = src; 
                            script.async           = true; 
                            script.id              ='buy2checkout'
                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                            script.onload          = function () {
                                $('.buy_box .btn').removeClass('load');
                                var isbuy=0;
                                for (var namespace in config) {
                                    if (config.hasOwnProperty(namespace)) {
                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                    } 
                                } 
                                window[libName].register();
                                TwoCoInlineCart.products.add({
                                    code: data.prod,
                                    quantity: data.qty,
                                });
                                try{
                                    if(data.test){
                                        TwoCoInlineCart.cart.setTest(true);
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                                if(data.lock){
                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                }else{
                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                }
                                if(data['empty-cart']){
                                    TwoCoInlineCart.cart.setReset(true)
                                }else{
                                    TwoCoInlineCart.cart.setReset(false)
                                }
                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                TwoCoInlineCart.cart.setSignature(data.signature)
                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                TwoCoInlineCart.cart.checkout();
                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                    console.log('cart:opened')
                                })
                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                    if(isbuy){
                                        $('.maskRights').show();
                                        if(getCookie('user')){
                                            $('.buySuccess.Member').show().siblings().hide();
                                            gaPush('buy_login','true')
                                        }else{
                                            $('.buySuccess.noMember').show().siblings().hide();
                                            gaPush('buy_login','false')
                                        }
                                    }
                                })
                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                    isbuy=1;
                                    gaPush('buy_success','')
                                })
                            }; 
                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                    }else if(gateway==6){
                        $('.maskRights').show()
                        if(getCookie('user')){
                            $('.buySuccess.Member').show().siblings().hide();
                        }else{
                            $('.buySuccess.noMember').show().siblings().hide();
                        }
                        console.log("3",newWindow);
                        newWindow.location.href = data.url_gateway;
                    }else if(gateway==7){
                        var key=JSON.parse(window.atob(data.url_gateway.split('base64,')[1]));
                        isbuy=0;
                        if(fastspringScript){
                            $('.buy_box .btn').removeClass('load');
                            fastspring.builder.promo(that.attr('coupon'))
                            fastspring.builder.secure(key.p,key.k)
                            fastspring.builder.checkout();
                        }else{
                            fastspringScript=document.createElement('script'); 
                            fastspringScript.src="https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js"; 
                            fastspringScript.async=true; 
                            fastspringScript.id='fsc-api'
                            fastspringScript.setAttribute('data-storefront',fast_storefront)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-popup-closed','fastspringDataPopupClosed')
                            fastspringScript.setAttribute('data-data-callback','fastspringDataCallback')
                            fastspringScript.setAttribute('data-popup-webhook-received','fastspringDataPopupWebhookReceived')
                            document.body.appendChild(fastspringScript)
                            fastspringScript.onload=function(){
                                $('.buy_box .btn').removeClass('load');
                                fastspring.builder.promo(that.attr('coupon'))
                                fastspring.builder.secure(key.p,key.k);
                                fastspring.builder.checkout();
                            }
                        }
                    }else{
                        isbuy=0;
                        // Paddle.Checkout.open({
                        //     override: data.url_gateway
                        // });
                    }
                    break
                case 25301:
                    that.removeClass('load')
                    error(i18n[lang].error_25301);
                    break;
                case 25302:
                    that.removeClass('load')
                    error(i18n[lang].error_25302);
                    break;
                case 25303:
                    that.removeClass('load')
                    error(i18n[lang].error_25303);
                    break;
                case 25304:
                    that.removeClass('load')
                    error(i18n[lang].error_25304);
                    break;
                case 25305:
                    that.removeClass('load')
                    error(i18n[lang].error_25305);
                    break;
                case 25306:
                    that.removeClass('load')
                    error(i18n[lang].error_25306);
                    break;
            }
        }
    ).error(function(xhr){
        that.removeClass('load')
        overtime(25399);
    });
}
// fastspring关闭回调
function fastspringDataPopupClosed(data){
    console.log(data);
    if(isbuy){
        if(user){
            $('.buySuccess.Member').show();
            $('.buySuccess.noMember').hide();
            $('.buyInner .mailto').text(personal.email)
            gaPush('buy_login','true')
        }else{
            $('.buySuccess.noMember').show();
            $('.buySuccess.Member').hide();
            gaPush('buy_login','false')
        }  
    }
}
// fastsprin回调
var is_fastspring_buy=0
var fastspring_data
var fastspring_data_buy
function fastspringDataCallback(data){
    fastspring_data=data
    var product_map = new Map(fastspring_data.groups[0].items.map(item => [item.product, item.display]));
    if(is_fastspring_buy==1){
        for(var i=0;i<fastspring_data_buy.items.length;i++){
            console.log(fastspring_data_buy.items[i].product)
            console.log(product_map[fastspring_data_buy.items[i].product])
            fastspring_data_buy.items[i].item_id=fastspring_data_buy.items[i].product
            fastspring_data_buy.items[i].item_name=product_map.get(fastspring_data_buy.items[i].product)
            fastspring_data_buy.items[i].price=fastspring_data_buy.items[i].subtotal
        }
        var purchase={
            event: "purchase",
            ecommerce: {
                transaction_id: fastspring_data_buy.id,
                value: fastspring_data_buy.total,
                tax: fastspring_data_buy.tax,
                currency: fastspring_data_buy.currency,
                item_brand: "FastSpring",
                items: fastspring_data_buy.items,
            },
        }
        console.log(purchase)
        dataLayer.push({ecommerce:null});
        dataLayer.push(purchase);
    }
    is_fastspring_buy=0
}
// fastspring购买成功回调
function fastspringDataPopupWebhookReceived(data){
    isbuy=1;
    is_fastspring_buy=1
    fastspring_data_buy=data
};
function autoIndex(a){
    var _index = -1;
    for(var i=0;i<plan_lists.length;i++){
        if(plan_lists[i]==Number(a)){ _index = i};
    };
    return _index;
};
$(document).ready(function(){
    if(window.location.search != ''){
      var value = getQueryVariable('plan_id');
      for(var j=0;j<$('.buy_main span.btn').length;j++){
        if($('.buy_main span.btn').eq(j).attr('attr-plan')==value.split(',')[0]){
            if(value.split(',')[1]&&autoIndex(value.split(',')[1])>=0){
                    $('.buy_main span.btn').eq(j).siblings('.check_box').find('i').trigger('click');
                    $('.buy_main span.btn').eq(j).siblings('.check_box').find('li').eq(autoIndex(value.split(',')[1])).trigger('click')
                };
            checkout($('.buy_main span.btn').eq(j));
        }
      }
    }
});
$('.buySuccess .close,.buySuccess .got').on('click',function(){
    $('.buySuccess').hide();
});